import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTranslation } from 'react-i18next';
import { ContainerVertical } from '@aftersale-next/ui';
import EventItem from './event-item';
import * as eventCode from '../../config/constants/event-code';
import ShowMoreEvents from './show-more';
import ChannelItem from './channel-item';
import { useTimeline } from '../../hooks/use-timeline';
import { useTimelineLength } from '../../hooks/use-timeline-length';
import { useTimelineActions } from '../../hooks/use-timeline-actions';
import { useTimelineExpanded } from '../../hooks/use-timeline-expanded';
import { usePackageId } from '../../hooks/use-package-id';
export default function EventList() {
  var events = useTimeline();
  var numberEvents = useTimelineLength();
  var actions = useTimelineActions();

  var _useTimelineExpanded = useTimelineExpanded(),
      _useTimelineExpanded2 = _slicedToArray(_useTimelineExpanded, 1),
      expanded = _useTimelineExpanded2[0];

  var packageId = usePackageId();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isFirst = function isFirst(index) {
    if (expanded) return index === numberEvents - 1;
    if (!expanded) return index === 1;
    return false;
  };

  return /*#__PURE__*/_jsxs(ContainerVertical, {
    align: "flex-start",
    children: [numberEvents === 0 && /*#__PURE__*/_jsx(EventItem, {
      packageId: packageId,
      actions: [],
      id: "first",
      code: eventCode.INIT,
      isFirst: true,
      isLast: true,
      date: 0,
      description: t('WAITING_NEW_EVENT'),
      details: t('WAITING_NEW_EVENT_MESSAGE'),
      disableBottomSpacer: true,
      disableConnector: true
    }, "waiting-event"), numberEvents === 1 && events.map(function (event) {
      if (Number(event.code) === eventCode.COURIER_UNKNOWN) {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }

      return /*#__PURE__*/_jsx(EventItem, {
        packageId: packageId,
        actions: [],
        code: eventCode.INIT,
        isLast: true,
        date: 0,
        id: "",
        description: t('WAITING_NEW_EVENT'),
        details: t('WAITING_NEW_EVENT_MESSAGE')
      }, "single-event");
    }), numberEvents === 1 && /*#__PURE__*/_jsx(EventItem, {
      isFirst: true,
      actions: actions,
      id: events[0].id,
      packageId: packageId,
      code: events[0].code,
      date: events[0].date,
      description: events[0].description,
      details: events[0].details,
      disableConnector: true,
      disableBottomSpacer: true
    }, events[0].description), numberEvents > 1 && events.filter(function (_, index) {
      return expanded ? true : index < 2;
    }).map(function (event, index) {
      return event.channel !== undefined ? /*#__PURE__*/_jsx(ChannelItem, {
        channel: event,
        actions: [],
        isLast: index === 0,
        isFirst: isFirst(index),
        disableConnector: numberEvents === 2 && index === 1,
        disableBottomSpacer: numberEvents === 2 && index === 1
      }, "channel-event-".concat(index)) : /*#__PURE__*/_jsx(EventItem, {
        actions: index === 0 ? actions : [],
        isLast: index === 0,
        isFirst: isFirst(index),
        id: event.id,
        packageId: packageId,
        code: event.code,
        date: event.date,
        description: event.description,
        details: event.details,
        disableConnector: numberEvents === 2 && index === 1,
        disableBottomSpacer: numberEvents === 2 && index === 1
      }, "".concat(event.description, "#").concat(event.date));
    }), /*#__PURE__*/_jsx(ShowMoreEvents, {})]
  });
}